export default __webpack_public_path__ + "static/images/invitation-preview-e3e58fc283ebd980e7724957cb5fc2e1.jpg";